import { render, staticRenderFns } from "./reviewed.vue?vue&type=template&id=0aabf1c8&scoped=true&"
import script from "./reviewed.vue?vue&type=script&lang=js&"
export * from "./reviewed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aabf1c8",
  null
  
)

export default component.exports